import { render, staticRenderFns } from "./SectionBlock.vue?vue&type=template&id=14536f07&scoped=true&"
import script from "./SectionBlock.vue?vue&type=script&lang=js&"
export * from "./SectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./SectionBlock.vue?vue&type=style&index=0&id=14536f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14536f07",
  null
  
)

export default component.exports